import { useTranslation } from 'react-i18next';

export default function FutureSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-primary-700 overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary-600 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-primary-800 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4" />
      <div className="absolute inset-0 bg-gradient-to-br from-secondary-900/10 to-transparent" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center">
        {/* Label */}
        <span className="inline-block text-xs md:text-sm text-secondary-400 font-medium tracking-widest uppercase mb-6">
          {t('future.label')}
        </span>

        {/* Title */}
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-10">
          {t('future.title')}
        </h2>

        {/* Content */}
        <div className="max-w-3xl mx-auto space-y-6">
          <p className="text-sm md:text-base text-background-200/90 leading-relaxed">
            {t('future.text1')}
          </p>
          <p className="text-sm md:text-base text-background-200/90 leading-relaxed">
            {t('future.text2')}
          </p>
          <p className="text-sm md:text-base text-background-200/90 leading-relaxed">
            {t('future.text3')}
          </p>
          <p className="font-heading text-xl md:text-2xl font-bold text-secondary-400 mt-8">
            {t('future.text4')}
          </p>
        </div>

        {/* Attribution */}
        <div className="mt-10 flex items-center justify-center gap-3">
          <div className="w-10 h-px bg-secondary-400/50" />
          <span className="text-sm text-background-300/70">
            {t('future.attribution')}
          </span>
          <div className="w-10 h-px bg-secondary-400/50" />
        </div>
      </div>
    </section>
  );
}